<template>
  <navigation-layout ref='navigationlayout'>
    <h1 slot="title">{{title}}</h1>
    <h3 slot="abstract">{{abstract}}</h3>
    <main>
      <div>
        <form novalidate class="md-layout md-alignment-top-center" @submit.prevent="validateTestFacility">
          <div class="md-layout-item md-max-size md-medium-size-33 md-small-size-50 md-xsmall-size-100">

            <field fieldName="facilityUrl" ref="facilityUrl" :validations="{required: true}" :fieldValue=form.facilityUrl
              fieldLabel="Facility url" fieldId="facilityUrl" :sending="sending" @setfield="setFormField($event)" />

            <field fieldName="facilityName" ref="facilityName" :validations="{required: true}" :fieldValue=form.facilityName
              fieldLabel="Facility name" fieldId="facilityName" :sending="sending" @setfield="setFormField($event)" />

            <field-select fieldName="integratorId" ref="integratorId" :validations="{required: true}" :fieldValue="form.integratorId"
              fieldLabel="Integrator" fieldId="integratorId" :values="integrators" valueId="id" valueLabel="name"
              :sending="sending" @setfield="setFormField($event)" withId=true />

            <field-select fieldName="timeZoneId" ref="timeZoneId" :validations="{required: true}" :fieldValue="form.timeZoneId"
              fieldLabel="TimeZone" fieldId="timeZoneId" :values="timeZones" valueId="timeZoneId" valueLabel="name"
              :sending="sending" @setfield="setFormField($event)" withId=true />

            <field-select fieldName="countryId" ref="countryId" :validations="{required: true}" :fieldValue="form.countryId"
              fieldLabel="Country" fieldId="countryId" :values="countries" valueId="countryId" valueLabel="name"
              :sending="sending" @setfield="setFormField($event)" withId=true />

            <field-select fieldName="languageId" ref="languageId" :validations="{required: true}" :fieldValue="form.languageId"
              fieldLabel="Language" fieldId="languageId" :values="languages" valueId="id" valueLabel="name" :sending="sending"
              @setfield="setFormField($event)" withId=true />

            <label class="md-title">Available modules</label>

            <div class="md-layout" >
              <div class="md-layout-item md-size-15 md-medium-size-35 md-small-size-50" v-for="(module, index) in modulesLayer" :key="index">
                <md-checkbox v-model="tempModules" :value="module" :disabled="module.name === 'CORE'">{{module.name}}</md-checkbox>
              </div>
            </div>

            <md-progress-bar md-mode="indeterminate" v-if="sending || loading" />
            <md-button type="submit" class="md-raised md-primary" :disabled="sending || loading">Create</md-button>
            <md-dialog :md-active.sync="showResultDialog">
              <md-dialog-title>Results</md-dialog-title>
              <md-list v-if="createdTestFacilityData !==null" class="md-double-line">
                <md-list-item>
                  <div class="md-list-item-text">
                    <span>ApiKey</span>
                    <span>{{createdTestFacilityData.apiKey}}</span>
                  </div>
                </md-list-item>
                <md-list-item>
                  <div class="md-list-item-text">
                    <span>FacilityUrl</span>
                    <span>{{createdTestFacilityData.facilityUrl}}</span>
                  </div>
                </md-list-item>
                <md-list-item>
                  <div class="md-list-item-text">
                    <span>Director Username</span>
                    <span>{{createdTestFacilityData.directorUsername}}</span>
                  </div>
                </md-list-item>
                <md-list-item>
                  <div class="md-list-item-text">
                    <span>Director Password</span>
                    <span>{{createdTestFacilityData.directorPassword}}</span>
                  </div>
                </md-list-item>
                <md-list-item>
                  <div class="md-list-item-text">
                    <span>Integration Username</span>
                    <span>{{createdTestFacilityData.integrationUsername}}</span>
                  </div>
                </md-list-item>
                <md-list-item>
                  <div class="md-list-item-text">
                    <span>Integration Password</span>
                    <span>{{createdTestFacilityData.integrationPassword}}</span>
                  </div>
                </md-list-item>
              </md-list>
              <md-dialog-actions>
                <md-button class="md-primary" @click="showResultDialog = false">Close</md-button>
              </md-dialog-actions>
            </md-dialog>
          </div>
        </form>
      </div>
    </main>
  </navigation-layout>
</template>

<script>
import NavigationLayout from '@/components/layouts/navigation'
import RepositoryService from '@/services/repositoryService'
import NotificationService from '@/services/notificationService'
import Utils from '@/utils/utils'
import Field from '@/components/elements/field'
import FieldSelect from '@/components/elements/select'

export default {
  name: 'create-test-facility',
  data: () => ({
    form: {
      facilityUrl: null,
      facilityName: null,
      integratorId: null,
      timeZoneId: null,
      countryId: null,
      languageId: null,
      modules: [],
      billingCompanyFacilityId: RepositoryService.session.selectedBillingCompany.id,
      directorUsername: null,
      directorPassword: null,
      integrationUsername: null,
      integrationPassword: null
    },
    sending: false,
    loading: true,
    createdTestFacilityData: null,
    integrators: null,
    countries: null,
    timeZones: null,
    languages: null,
    tempModules: [],
    modules: null,
    modulesLayer: null,
    showResultDialog: false,
    title: 'Create Test Facility',
    abstract: 'Create a test facility for integrator'
  }),
  components: {
    NavigationLayout,
    Field,
    FieldSelect
  },
  methods: {
    setFormField (fieldObj) {
      this.form[fieldObj.fieldName] = fieldObj.fieldValue
    },
    async validateTestFacility () {
      var results = []
      for (var property in this.$refs) {
        if (this.$refs.hasOwnProperty(property) && this.$refs[property].validateField) {
          results.push(await this.$refs[property].validateField())
        }
      }
      var canSave = results.every((value) => {
        return value
      })
      if (!(this.tempModules && this.tempModules.length === 0)) {
        this.form.modules = Utils.modulesLayerToModuleIds(this.tempModules)
      }

      if (canSave) {
        this.sending = true
        await this.createTestFacility()
        this.sending = false
      }
    },
    clearForm () {
      this.form.facilityUrl = null
      this.form.facilityName = null
      this.form.integratorId = null
      this.form.timeZoneId = null
      this.form.languageId = null
      this.form.modules = []
      this.form.billingCompanyFacilityId = RepositoryService.session.selectedBillingCompany.id
      this.form.directorUsername = null
      this.form.directorPassword = null
      this.form.integrationUsername = null
      this.form.integrationPassword = null
      for (var property in this.$refs) {
        if (this.$refs.hasOwnProperty(property) && this.$refs[property].clearField) {
          this.$refs[property].clearField()
        }
      }
    },
    async createTestFacility () {
      await NotificationService.manageNotification(this, await RepositoryService.createTestFacility(this.form),
        this.callback)
    },
    callback (data) {
      this.createdTestFacilityData = data
      this.startDownloadData(data)
      this.clearForm()
      this.showResultDialog = true
    },
    startDownloadData (data) {
      let blob = new Blob([JSON.stringify(this.createJsonData(data))], {
        type: 'application/json'
      })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${this.form.facilityName} - TEST.postman_environment.json`
      link.click()
    },
    createJsonData (data) {
      return {
        'name': `${this.form.facilityName} - TEST`,
        'values': [{
          'key': 'ApiKey',
          'value': data.apiKey,
          'enabled': true
        },
        {
          'key': 'FacilityUrl',
          'value': this.form.facilityUrl,
          'enabled': true
        },
        {
          'key': 'Username',
          'value': data.integrationUsername,
          'enabled': true
        },
        {
          'key': 'Password',
          'value': data.integrationPassword,
          'enabled': true
        }
        ]
      }
    }
  },
  created: async function () {
    this.loading = true
    await NotificationService.manageNotification(this, await RepositoryService.getIntegrators(),
      (data) => {
        this.integrators = data.integrators.sort(Utils.orderArrayObjectByFieldNumberAsc('name'))
      })

    await NotificationService.manageNotification(this, await RepositoryService.getIntegratorInfo(),
      (data) => {
        this.modules = data.modules.sort(Utils.orderArrayObjectByFieldNumberAsc('id'))
      })

    await NotificationService.manageNotification(this, await RepositoryService.getLists(),
      (data) => {
        this.countries = data.countries.sort(Utils.orderArrayObjectByFieldNumberAsc('countryId'))
        this.timeZones = data.timezones.sort(Utils.orderArrayObjectByFieldNumberAsc('baseUtcOffset'))
        this.languages = data.languages.sort(Utils.orderArrayObjectByFieldNumberAsc('id'))
      })

    this.modulesLayer = Utils.modulesToModuleLayers(this.modules)
    for (var i = 0; i < this.modulesLayer.length; i++) {
      if (this.modulesLayer[i].name === 'CORE') {
        this.tempModules.push(this.modulesLayer[i])
      }
    }
    this.loading = false
  }
}

</script>

<style lang="scss" scoped>
  md-dialog {
    max-width: 768px;
  }

</style>
